import { Injectable } from '@angular/core';
import { BaseclientService } from '../baseclient.service';
import { ToolsService } from '../../tools/tools.service';
import { Router } from '@angular/router';
import { Observable, from, BehaviorSubject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { PanierService } from '../../manage/panier/panier.service';
import * as moment from 'moment';
import { ClientaddressesService } from '../clientaddresses/clientaddresses.service';
import { SalemethodService } from '../../api/salemethod/salemethod.service';
import { PhoneService } from '../phone/phone.service';
import { TranslateService } from '@ngx-translate/core';
import { OrderEncoderService } from '../../success-order-encoder.service';

@Injectable({
  providedIn: 'root'
})

export class ClientOrdersService {
  private errorOrderData: BehaviorSubject<any> = new BehaviorSubject(null);
  get getErrorOrderData(): Observable<string> { return this.errorOrderData.asObservable(); }
  //error phone
  private errorPhone: BehaviorSubject<any> = new BehaviorSubject(null);
  get getErrorPhone(): Observable<string> { return this.errorPhone.asObservable(); }
  errorPhoneFormat: any

  constructor(
    private baseClient: BaseclientService,
    private tools: ToolsService,
    private router: Router,
    private panierPan: PanierService,
    private addressApi: ClientaddressesService,
    private smApi: SalemethodService,
    private PhoneApi: PhoneService,
    public translate: TranslateService,
    private orderEncoderService: OrderEncoderService,
  ) { }

  // TODO Jamais utilisée
  // submitOrder_(
  //   currCard: any,
  //   billingAddress: any,
  //   delivryaddress: any,
  //   relay: any,
  //   paypal_order_id?: string | null,
  //   payment_intent_id?: string | null,
  //   merchantClient?: any,
  //   paymentIntentId?: any,
  //   order_id_device?: any
  // ): Promise<any> {
  //   const panier: any = this.tools.getStor(PanierService.TAG_STORAGE);
  //   const dateOrder: any = this.tools.getStor("date_order");
  //   const infoNote: any = this.tools.getStor("infos_note");
  //   const hourOrder: any = this.tools.getStor("hour_order");
  //   const pointOfSale: any = this.tools.getStor("point_of_sale");
  //   const saleMeth: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
  //   let id_merchant = this.tools.getStor("id_merchant");
  //   const params: any = {
  //     payment_type: saleMeth.payment_type,
  //     use_client_credit: saleMeth.use_client_credit,
  //     use_client_credit_fid: saleMeth.use_client_credit_fid,
  //     basket: panier,
  //     pos_id: pointOfSale.id,
  //     sm_id: saleMeth.id,
  //     address_billing_id: billingAddress ? billingAddress.address_id : null,
  //     id_merchant: id_merchant
  //   };
  //   // Stripe
  //   if (saleMeth.payment_type === "online" || saleMeth.payment_type === "secure_counter") {
  //     payment_intent_id ? params["payment_intent_id"] = payment_intent_id : params["payment_method_id"] = currCard.id;
  //   } else if (saleMeth.payment_type === "bancontact" && payment_intent_id) {
  //     params["payment_intent_id"] = payment_intent_id;
  //   } else if (saleMeth.payment_type === "payzen") {
  //     params["payment_intent_id"] = payment_intent_id;
  //   } else if (saleMeth.payment_type === "stripe" && payment_intent_id) {
  //     params["payment_intent_id"] = payment_intent_id;
  //   }
  //   // Paypal
  //   if (saleMeth.payment_type === "online_paypal" || saleMeth.payment_type === "secure_counter_paypal") {
  //     params["paypal_order_id"] = paypal_order_id ? paypal_order_id : null;
  //   }
  //   if (saleMeth.payment_type === "yavin") {
  //     const myurl = window.location.origin + '/endorder';
  //     params['url_success'] = myurl;
  //     params['url_cancelled'] = myurl;
  //   }
  //   // Address && relay
  //   if (relay) {
  //     params["relay_id"] = relay.Num;
  //     params["shipping_mode_id"] = relay.shipping_mode.id;
  //   } else {
  //     if (saleMeth.enable_delivery > 0 || saleMeth.enable_shipping_cost > 0) {
  //       params["address_id"] = delivryaddress.address_id
  //       if (saleMeth.enable_shipping_cost > 0 && delivryaddress.shipping_mode) {
  //         params["shipping_mode_id"] = delivryaddress.shipping_mode.id;
  //       }
  //     }
  //   }
  //   // Date
  //   if (saleMeth.enable_shipping_cost < 1) {
  //     params["date_order"] = saleMeth.enable_date_hour ? moment(dateOrder).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
  //     params["hour_order"] = saleMeth.enable_date_hour ? moment(hourOrder).format("HH:mm:ss") : moment().add(30, 'seconds').format("HH:mm:ss");
  //   } else {
  //     params["date_order"] = moment().format("YYYY-MM-DD");
  //   }
  //   // Info
  //   if (infoNote) {
  //     let arrayInfo: any = [];
  //     infoNote.forEach((element: any) => {
  //       if ((element.is_phone == 1 && element.value) || !element.is_phone) {
  //         arrayInfo.push(element);
  //       }
  //     });
  //     params["infos_note"] = arrayInfo;
  //   }
  //   // dev
  //   params["dev"] = "fc";
  //   params['metadata'] = "1" //provenance order
  //   if (merchantClient && merchantClient.id_group) {
  //     params['merchantClient'] = merchantClient.id_group;
  //   }
  //   //stripe
  //   if (paymentIntentId) {
  //     params['paymentIntentId'] = paymentIntentId;
  //   }
  //   //device checheck
  //   if (order_id_device) {
  //     params['order_id_device'] = order_id_device;
  //   }
  //   return this.baseClient.postBase("createOrderSCA_", params);
  // }

  checkError(
    currCard: any,
    billingAddress: any,
    delivryAddress: any,
    relay: any,
    isRelay: boolean,
    uberFee: number,
  ): Promise<any> {
    // console.log("clientorders.service - checkError -  uberFee : ", uberFee);
    const panier: any = this.tools.getStor(PanierService.TAG_STORAGE);
    let dateOrder = this.tools.getStor("date_order");
    let infoNote: any = this.tools.getStor("infos_note");
    let hourOrder = this.tools.getStor("hour_order");
    const methodvente: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
    //si aucune heure on set à now
    if (!methodvente.enable_date_hour) {
      dateOrder = moment().format("YYYY-MM-DD");
      hourOrder = moment().add(30, 'seconds').format("HH:mm:ss")
    }
    let error: any = null;
    let errorNote: any = null;
    if (infoNote) {
      errorNote = infoNote.filter((info: any) => !info.value && info.sale_methods[0].compulsory === 1);
    }
    if (!panier) { // ???
    } else if (this.panierPan.getPrice() < methodvente.minimum_order) {
      error = "miniamount";
    }
    // date et hour
    if (methodvente.enable_date_hour && !dateOrder) {
      error = "dateorder";
    } else if (methodvente.enable_date_hour && !hourOrder) {
      error = "hourorder";
    } else if (methodvente.enable_date_hour && moment(dateOrder).isBefore(moment(), "day")) {
      error = "invalidDate";
    } else if (methodvente.enable_date_hour && moment(dateOrder).isSame(moment(), "day") && moment(hourOrder).isBefore(moment())) {
      error = "invalidhour";
    } else if (methodvente.enable_date_hour && methodvente.payment_type === "secure_counter" && moment(dateOrder).isAfter(moment().add(4, 'days'))) {
      error = "counterdate";
    } else if (errorNote && errorNote.length > 0) {
      error = errorNote[0].id;
    } else if (!billingAddress && methodvente.enable_billing_address) {
      error = "billingaddress";
    } else if (isRelay && !relay) {
      error = "relayneeded";
    } else if (methodvente.enable_delivery > 0 && !delivryAddress && !isRelay || methodvente.enable_shipping_cost > 0 && !delivryAddress && !isRelay) {
      error = "delivryaddress";
    } else if (methodvente.enable_shipping_cost > 0 && this.addressApi.getShippingPrice(panier, isRelay ? relay : null) === -1) {
      error = "maxweight";
    } else if (methodvente.enable_shipping_cost > 0 && this.addressApi.getShippingPrice(panier, isRelay ? relay : null) === -2) {
      error = "countryshipping";
    } else if (methodvente.enable_delivery > 0 && this.panierPan.getPanInfos("delivery") === null && uberFee <= 0) {
      // console.log("clientorders.service - checkError - uberFee : ", uberFee);
      error = "citydelivery";
    } else if (!currCard && methodvente.payment_type === "online" || !currCard && methodvente.payment_type === "secure_counter"
      || methodvente.payment_type === "touch_terminal" && !this.tools.getStor("devicePaybridge")) {
      error = "paimentcard";
    }

    return new Promise((resolve) => {
      this.smApi.getSaleMethods().subscribe(async (saleMeths) => {
        if (!Array.isArray(saleMeths)) {
          console.error("ERREUR : saleMeths est invalide", saleMeths);
          resolve("salemethods_error");
          return;
        }
        let currSm = saleMeths.find((value: any) => value.id == methodvente.id);
        if (currSm && currSm.archive > 0) {
          resolve("currSalemethodArchive");
        } else if (error) {
          console.error('error:', error)
        }
        //infonote telephone
        let checkPhoneInfoNote = null;
        if (infoNote && !error) {
          checkPhoneInfoNote = infoNote.filter((info: any) => info.value && info.is_phone === 1);
        }
        if (checkPhoneInfoNote && checkPhoneInfoNote.length > 0) {
          this.checkPhoneMain(checkPhoneInfoNote, infoNote).then(value => {
            error = value ? "ErrorPhone" : null;
            if (methodvente.disable_authentification) {
              error = this.check_disable_authentification(error, errorNote);
              if (!error) {
                this.check_enable_shipping_cost(methodvente, error).then(err => {
                  resolve(err);
                })
              } else {
                resolve(error);
              }
            } else {
              this.check_enable_shipping_cost(methodvente, error).then(err => {
                resolve(err);
              })
            }
          });
        } else {
          if (methodvente.disable_authentification) {
            error = this.check_disable_authentification(error, errorNote);
            if (!error) {
              this.check_enable_shipping_cost(methodvente, error).then(err => {
                resolve(err);
              })
            } else {
              resolve(error);
            }
          } else {
            this.check_enable_shipping_cost(methodvente, error).then(err => {
              resolve(err);
            })
          }
        }
      })
    });
  }

  check_disable_authentification(error: any, errorNote: any) {
    if (error && (error !== "billingaddress"
      || error !== "relayneeded"
      || error !== "delivryaddress"
      || error !== "maxweight"
      || error !== "countryshipping"
      || error !== "citydelivery")
      || (errorNote && errorNote.length > 0)) {
      if (errorNote && errorNote.length > 0) {
        error = errorNote[0].id;
      }
      return (error);
    } else {
      return null;
    }
  }

  check_enable_shipping_cost(methodvente: any, error: any) {
    return new Promise(resolve => {
      if (methodvente.enable_shipping_cost < 1 && !error) {
        this.checkLimitSlot().then(data => {
          if (data.code === -45) {
            error = "invalidslot";
          } else if (data.code === -49) {
            this.setErrorOrderData(data.error_rub);
            error = "invalidrub";
          } else if (data.code === -75) {
            this.setErrorOrderData(data);
          } else if (data.code == -201) {
            this.setErrorOrderData(data);
            error = "invalidDateproduct";
          }
          resolve(error);
        });
      } else {
        resolve(error);
      }
    });
  }

  async checkPhoneMain(checkPhoneInfoNote: any, infoNote: any) {
    let error = false;
    let errorPhone = {
      message: null,
      id: null
    }
    for (const iterator of checkPhoneInfoNote) {
      //on attend la reponse
      const result: any = await this.checkPhone(iterator);
      //error break
      if (result.code && result.code < 0) {
        errorPhone.message = result.message;
        errorPhone.id = iterator.id
        error = true;
        break;
      } else {
        iterator.value = result.phone;
      }
    }
    if (error) {
      // set error
      this.setErrorPhone(errorPhone);
      return error;
    } else {
      this.tools.setStor("infos_note", infoNote);
    }
    return;
  }

  checkPhone(element: any) {
    return new Promise(resolve => {
      this.PhoneApi.ckeckPhone(element.country_id, element.value).then((phone) => {
        resolve(phone);
      })
    });
  }


  setInfonote(infoNote: any) {
    let newinfoNote: any = [];
    infoNote.forEach((element: any) => {
      if (element.value) {
        newinfoNote.push(element)
      }
    });
    this.tools.setStor("infos_note", newinfoNote);
  }

  redirectAfterErrorYetCaptured() {
    this.tools.removeStor("infos_note");
    this.tools.removeStor(PanierService.TAG_STORAGE);
    this.tools.removeStor("payment_save_order");
    this.tools.removeStor("payment_save_order_stripe");
    this.tools.removeStor("credit_fid");
    this.tools.removeStor("order_id");
    this.tools.removeStor("ClientKeyPayIntentOrder");
    this.tools.goProductPage();
  }

  private sanitizeUberTrackingUrl(value?: unknown): string | undefined {
    const PREFIX = "https://delivery.uber.com/fr/orders/";

    if (typeof value !== "string") return undefined;

    const v = value.trim();
    if (!v.startsWith(PREFIX)) return undefined;

    return v;
  }

  async endOrder(uber_tracking_url?: string) {
    let order_id = this.tools.getStor("order_id");

    try {
      await this.createOrderLevel(order_id);

      let currdevice = this.tools.getStor("devicePaybridge") ? this.tools.getStor("devicePaybridge") : null;
      let currdevicePrintAuto = currdevice ? this.tools.getStor("devicePaybridgePrint") : null;
      let smid = currdevice && this.tools.getStor("smId") ? this.tools.getStor("smId") : null;
      const saleMeth: any = this.tools.getStor(SalemethodService.TAG_STORAGE);

      // sanitize de l'url de uber
      const safeUberTrackingUrl = this.sanitizeUberTrackingUrl(uber_tracking_url);

      // console.log("clientorders.service - endOrder - parseInt(order_id) : ", parseInt(order_id))
      // console.log("clientorders.service - endOrder - uber_tracking_url : ", safeUberTrackingUrl)

      const result = await this.orderEncoderService.encodeOrderId(
        parseInt(order_id),
        safeUberTrackingUrl
      );

      // Extrait le hash
      const encodedHash = result.hash;

      // Navigation avec le hash UNIQUEMENT
      if (saleMeth && saleMeth.disable_authentification) {
        this.router.navigate(["/successOrder", encodedHash], {
          queryParams: {
            disable_authentification: saleMeth.disable_authentification,
          }
        });
      } else {
        this.router.navigate(["/successOrder", encodedHash]);
        this.tools.openSnackBar(this.translate.instant('mailsend'), 'great', 5000);
      }

      // Nettoyage
      this.tools.clearStor();
      currdevice ? this.tools.setStor("devicePaybridge", currdevice) : null;
      currdevicePrintAuto ? this.tools.setStor("devicePaybridgePrint", currdevicePrintAuto) : null;
      smid ? this.tools.setStor("smId", smid) : null;

    } catch (error) {
      console.error("Erreur dans endOrder:", error);
    }
  }

  getOrder(orderId: string | number): Observable<any> {
    const params = { order_id: orderId }
    return from(this.baseClient.postBase("getOrder", params)).pipe(
      map(data => {
        return data.client_order;
      })
    )
  }

  getOrders(dateFrom?: string, dateTo?: string): Observable<any> {
    const params = {
      date_from: dateFrom,
      date_to: dateTo
    }
    return from(this.baseClient.postBase("getOrders", params)).pipe(
      map(data => data.client_orders)
    )
  }

  checkLimitSlot(dateOrder?: any, hourOrder?: any): Promise<any> {
    const date: any = dateOrder ? dateOrder : this.tools.getStor("date_order");
    const hour: any = hourOrder ? hourOrder : this.tools.getStor("hour_order");
    const pos: any = this.tools.getStor("point_of_sale");
    const sm: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
    let id_merchant = this.tools.getStor("id_merchant");
    const params: any = {
      basket: this.tools.getStor(PanierService.TAG_STORAGE),
      pos_id: pos.id,
      sm_id: sm.id,
      date_order: date ? moment(date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
      hour_order: hour ? moment(hour).format("HH:mm:ss") : moment().add(30, 'seconds').format("HH:mm:ss"),
      id_merchant: id_merchant,
      order_id: this.tools.getStor("order_id"),
    }
    return this.baseClient.postBase("checkLimitSlot", params);
  }

  getValidSlots(dateOrder?: any, hour?: any, basket?: any): Promise<any> {
    const date = dateOrder ? dateOrder : this.tools.getStor("date_order");
    const pos: any = this.tools.getStor("point_of_sale");
    const sm: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
    const params = {
      pos_id: pos.id,
      sm_id: sm.id,
      date_order: date ? moment(date).format("YYYY-MM-DD") : null,
      hour_order: dateOrder && hour ? (moment(date).format("YYYY-MM-DD") + ' ' + hour) : null,
      id_merchant: this.tools.getStor("id_merchant"),
      basket: basket ? basket : null
    }
    return this.baseClient.postBase("getValidSlots_", params);
  }

  // Récupération des créneaux horaire disponibles
  getValidSlotsPof(sm_id: any): Promise<any> {
    // Point de vente
    const pos: any = this.tools.getStor("point_of_sale");
    const params = {
      pos_id: pos.id,
      sm_id: sm_id,
      id_merchant: this.tools.getStor("id_merchant"),
    }
    return this.baseClient.postBase("getValidSlots_", params);
  }

  setErrorOrderData(error: any) {
    this.errorOrderData.next(error);
  }

  setPaymentPayzen(orderId: string | number, jsonPayzen: any, order_payment_id: any): Promise<any> {
    const params = {
      order_id: orderId,
      jsonPayzen: jsonPayzen,
      basket: this.tools.getStor(PanierService.TAG_STORAGE) ? this.tools.getStor(PanierService.TAG_STORAGE) : null,
      fidelityDiscountUsed: this.tools.getStor("credit_fid") ? this.tools.getStor("credit_fid") : null,
      order_payment_id: order_payment_id
    };
    return this.baseClient.postBase("payzenPaymentSucceeded", params);
  }

  setErrorPhone(error: any) {
    this.errorPhone.next(error);
  }

  stripePaymentSucceeded(order_id: any, payment_intent: any): Promise<any> {
    const params = {
      order_id: order_id,
      payment_intent: payment_intent,
      basket: this.tools.getStor(PanierService.TAG_STORAGE) ? this.tools.getStor(PanierService.TAG_STORAGE) : null,
      fidelityDiscountUsed: this.tools.getStor("credit_fid") ? this.tools.getStor("credit_fid") : null,
    };
    return this.baseClient.postBase("paymentSucceeded", params);
  }

  yavinPaymentSucceeded(order_id: any, status: any): Promise<any> {
    const pointOfSale: any = this.tools.getStor("point_of_sale");
    const params = {
      order_id: order_id,
      order_payment: order_id,
      status: status,
      basket: this.tools.getStor(PanierService.TAG_STORAGE) ? this.tools.getStor(PanierService.TAG_STORAGE) : null,
      fidelityDiscountUsed: this.tools.getStor("credit_fid") ? this.tools.getStor("credit_fid") : null,
      pos_id: pointOfSale.id,
    };
    return this.baseClient.postBase("yavinPaymentSucceeded", params);
  }

  checkOrderAmount(
    billingAddress: any,
    delivryaddress: any,
    relay: any,
    merchantClient?: any,
    checkopenpof?: any,
    uberFee?: number,
  ): Promise<any> {
    const panier: any = this.tools.getStor(PanierService.TAG_STORAGE);
    const pointOfSale: any = this.tools.getStor("point_of_sale");
    const saleMeth: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
    const dateOrder: any = this.tools.getStor("date_order");
    const hourOrder: any = this.tools.getStor("hour_order");
    const params: any = {
      payment_type: saleMeth.payment_type,
      use_client_credit: saleMeth.use_client_credit,
      use_client_credit_fid: saleMeth.use_client_credit_fid,
      basket: panier,
      pos_id: pointOfSale.id,
      sm_id: saleMeth.id,
      address_billing_id: billingAddress ? billingAddress.address_id : null,
      id_merchant: this.tools.getStor("id_merchant")
    };
    // Address && relay
    if (relay) {
      params["relay_id"] = relay.Num;
      params["shipping_mode_id"] = relay.shipping_mode.id;
    } else {
      if (saleMeth.enable_delivery > 0 || saleMeth.enable_shipping_cost > 0) {
        params["address_id"] = delivryaddress.address_id
        if (saleMeth.enable_shipping_cost > 0 && delivryaddress.shipping_mode) {
          params["shipping_mode_id"] = delivryaddress.shipping_mode.id;
        }
      }
    }
    if (merchantClient.id_group) {
      params['merchantClient'] = merchantClient.id_group;
    }
    // uber direct
    if (uberFee && uberFee > 0)
      params['uberFee'] = uberFee
    //enable_date_hour
    if (checkopenpof && saleMeth.enable_shipping_cost < 1) {
      params["date_order"] = saleMeth.enable_date_hour ? moment(dateOrder).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
      params["hour_order"] = saleMeth.enable_date_hour ? moment(hourOrder).format("HH:mm:ss") : moment().add(30, 'seconds').format("HH:mm:ss");
      params["checkpofOpen"] = true;
    }
    params["dev"] = "fc";
    // console.log("clientorders.service - checkOrderAmount - params :", params)
    return this.baseClient.postBase("checkOrderAmount", params);
  }

  myPosPaymentSucceeded(order_id: any, jsonMypos: any): Promise<any> {
    const params = {
      order_id: order_id,
      jsonMypos: jsonMypos,
      basket: this.tools.getStor(PanierService.TAG_STORAGE) ? this.tools.getStor(PanierService.TAG_STORAGE) : null,
      fidelityDiscountUsed: this.tools.getStor("credit_fid") ? this.tools.getStor("credit_fid") : null,
    };
    return this.baseClient.postBase("mypospaymentSuccess", params);
  }

  submitOrder(
    payment_type?: any,
    currCard?: any,
    billingAddress?: any,
    delivryaddress?: any,
    relay?: any,
    paypal_order_id?: string | null,
    payment_intent_id?: string | null,
    merchantClient?: any,
    paymentIntentId?: any,
    order_id_device?: any,
    url?: any,
    payment_intent_id_saved?: any,
    uberFee?: number,
  ): Promise<any> {
    const panier: any = this.tools.getStor(PanierService.TAG_STORAGE);
    const dateOrder: any = this.tools.getStor("date_order");
    const infoNote: any = this.tools.getStor("infos_note");
    const hourOrder: any = this.tools.getStor("hour_order");
    const pointOfSale: any = this.tools.getStor("point_of_sale");
    const saleMeth: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
    const order_id: any = this.tools.getStor("order_id") ? this.tools.getStor("order_id") : null;
    let id_merchant = this.tools.getStor("id_merchant");
    const params: any = {
      basket: panier,
      pos_id: pointOfSale.id,
      sm_id: saleMeth.id,
      id_merchant: id_merchant
    };
    if (order_id) {
      params['order_id'] = order_id;
    }
    // Mode finalisation de commande
    // On envoit la commande avec un mode de réglement
    if (payment_type) {
      // Mode vérification appareil
      // Commande à table
      // On force le paiement au comptoir
      if (saleMeth.enable_device_check == 1) {
        saleMeth.payment_type = "counter";
      }
      params['payment_type'] = saleMeth.payment_type;
      params['use_client_credit'] = saleMeth.use_client_credit;
      params['use_client_credit_fid'] = saleMeth.use_client_credit_fid;
      params['address_billing_id'] = billingAddress ? billingAddress.address_id : null;
      // Stripe
      if (saleMeth.payment_type === "online" || saleMeth.payment_type === "secure_counter") {
        payment_intent_id ? params["payment_intent_id"] = payment_intent_id : params["payment_method_id"] = currCard.id;
        if (payment_intent_id_saved) {
          params["payment_intent_id_saved"] = payment_intent_id_saved;
        }
      } else if (saleMeth.payment_type === "bancontact" && payment_intent_id) {
        params["payment_intent_id"] = payment_intent_id;
      } else if (saleMeth.payment_type === "payzen") {
        params["payment_intent_id"] = payment_intent_id;
      } else if (saleMeth.payment_type === "stripe" && payment_intent_id) {
        params["payment_intent_id"] = payment_intent_id;
      }
      // Paypal
      if (saleMeth.payment_type === "online_paypal" || saleMeth.payment_type === "secure_counter_paypal") {
        params["paypal_order_id"] = paypal_order_id ? paypal_order_id : null;
      }
      if (saleMeth.payment_type === "yavin") {
        const myurl = window.location.origin + '/endorder';
        params['url_success'] = myurl;
        params['url_cancelled'] = myurl;
      }
      // Address && relay
      if (relay) {
        params["relay_id"] = relay.Num;
        params["shipping_mode_id"] = relay.shipping_mode.id;
      } else {
        if (saleMeth.enable_delivery > 0 || saleMeth.enable_shipping_cost > 0) {
          params["address_id"] = delivryaddress.address_id
          if (saleMeth.enable_shipping_cost > 0 && delivryaddress.shipping_mode) {
            params["shipping_mode_id"] = delivryaddress.shipping_mode.id;
          }
        }
      }
      // Info
      if (infoNote) {
        let arrayInfo: any = [];
        infoNote.forEach((element: any) => {
          if ((element.is_phone == 1 && element.value) || !element.is_phone) {
            arrayInfo.push(element);
          }
        });
        params["infos_note"] = arrayInfo;
      }
      params["payment_intent_id_saved"] = this.tools.getStor("ClientKeyPayIntenCard") ? this.tools.getStor("ClientKeyPayIntenCard").id : null
      params["payment_intent_id_saved_stripe_widget"] = this.tools.getStor("ClientKeyPayIntentOrder") ? this.tools.getStor("ClientKeyPayIntentOrder").paymentIntent.id : null;
    }
    // Date
    if (saleMeth.enable_shipping_cost < 1) {
      params["date_order"] = saleMeth.enable_date_hour ? moment(dateOrder).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
      params["hour_order"] = !hourOrder && saleMeth.enable_date_hour ? moment().format("HH:mm:ss") : saleMeth.enable_date_hour ? moment(hourOrder).format("HH:mm:ss") : moment().add(30, 'seconds').format("HH:mm:ss");
    } else {
      params["date_order"] = moment().format("YYYY-MM-DD");
    }
    // dev
    params["dev"] = "fc";
    params['metadata'] = "1" //provenance order
    if (merchantClient && merchantClient.id_group) {
      params['merchantClient'] = merchantClient.id_group;
    }
    //stripe
    if (paymentIntentId) {
      params['paymentIntentId'] = paymentIntentId;
    }
    //device checheck
    if (order_id_device) {
      params['order_id_device'] = order_id_device;
    }
    if (url) {
      params['url'] = url;
    }
    // uber direct
    if (uberFee && uberFee > 0)
      params['uberFee'] = uberFee
    return this.baseClient.postBase("command", params);
  }

  // get check Order Payment
  checkOrderPayment(id_order: any, payment_intent?: any): Promise<any> {
    let params: any = {
      id_order: id_order
    };
    if (payment_intent) {
      params['payment_intent'] = payment_intent.paymentIntent.id;
    }
    return this.baseClient.postBase("checkMyOrderPayment", params);
  }

  createOrderLevel(order_id: any): Promise<any> {
    const pos: any = this.tools.getStor("point_of_sale");
    const params = {
      pos_id: pos.id,
      order_id: order_id
    }
    return this.baseClient.postBase("createOrderLevel", params);
  }

  getOrderLevel(pos_id: number, order_id: number) {
    // const pos: any = this.tools.getStor("point_of_sale");
    const params = {
      pos_id: pos_id,
      order_id: order_id
    }
    return this.baseClient.postBase("getOrderLevels", params);
  }
}
